import { ApplicationRef, Component, ComponentRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit {
  constructor(private appRef: ApplicationRef) {}

  componentRef: ComponentRef<AlertComponent>;

  @ViewChild('childModal', { static: true }) public childModal: ModalDirective;

  callback: () => void;
  message: string;
  header: string;

  ngOnInit() {
    this.childModal.onHidden.subscribe(x => {
      this.callback();
    });
  }

  show(options: { header?: string; message?: string }) {
    setTimeout(() => {
      this.header = options.header;
      this.message = options.message;
      this.childModal.show();
    }, 0);

    return new Promise<void>(res => {
      this.callback = res;
    });
  }

  close() {
    this.childModal.hide();
    this.destroy();
  }

  destroy() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }
}
